/** Same-origin path to return to after login (never protocol-relative). */
export function redirectTarget(state: unknown): string {
  if (typeof state === 'object' && state !== null && 'from' in state) {
    const from = (state as { from?: { pathname?: unknown; search?: unknown; hash?: unknown } })
      .from;
    const pathname = from?.pathname;
    if (
      typeof pathname === 'string' &&
      pathname.startsWith('/') &&
      !pathname.startsWith('//') &&
      pathname !== '/login'
    ) {
      const search = typeof from?.search === 'string' ? from.search : '';
      const hash = typeof from?.hash === 'string' ? from.hash : '';
      return `${pathname}${search}${hash}`;
    }
  }
  return '/dashboard';
}
